var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "b-jumbotron",
        {
          attrs: {
            header: "User Log In",
            lead: "Welcome to Bio-Reactor Exyte ",
            "bg-variant": "info",
            "text-variant": "white",
            "border-variant": "dark"
          }
        },
        [
          _c("img", {
            attrs: {
              src: require("../assets/img/bioreator.png"),
              fluid: "",
              alt: "Fluid image",
              width: "200",
              height: "200"
            }
          }),
          _c(
            "b-row",
            { staticClass: "reg-form-input" },
            [
              _c("b-col", { attrs: { sm: "3" } }, [_vm._v("Username")]),
              _c(
                "b-col",
                { attrs: { sm: "6" } },
                [
                  _c("b-form-input", {
                    attrs: {
                      type: "text",
                      "aria-describedby": "inputLiveHelp inputLiveFeedback",
                      state: !!_vm.userLoginInfo.username
                    },
                    model: {
                      value: _vm.userLoginInfo.username,
                      callback: function($$v) {
                        _vm.$set(_vm.userLoginInfo, "username", $$v)
                      },
                      expression: "userLoginInfo.username"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "b-row",
            { staticClass: "reg-form-input" },
            [
              _c("b-col", { attrs: { sm: "3" } }, [_vm._v("Password")]),
              _c(
                "b-col",
                { attrs: { sm: "6" } },
                [
                  _c("b-form-input", {
                    attrs: {
                      type: "password",
                      "aria-describedby": "inputLiveHelp inputLiveFeedback",
                      state: !!_vm.userLoginInfo.password
                    },
                    nativeOn: {
                      keydown: function($event) {
                        _vm.enterKey($event)
                      }
                    },
                    model: {
                      value: _vm.userLoginInfo.password,
                      callback: function($$v) {
                        _vm.$set(_vm.userLoginInfo, "password", $$v)
                      },
                      expression: "userLoginInfo.password"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "b-button",
            {
              attrs: { variant: "primary" },
              on: {
                click: function($event) {
                  _vm.userlogin()
                }
              }
            },
            [_vm._v("Log In")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c27482c4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c27482c4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/Login.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-c27482c4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/Login.vue
// module chunks = 7